export default "__VITE_ASSET__iv$ovj0u__"